import { color, radius } from '../../theme/tokens.js';
import { Skeleton } from '../States/States.js';

/**
 * The loading silhouette: banner, filter bar, rows. ⚠ No digits and no chip in red — a placeholder
 * that looks like a flag is a fabricated flag (the Audit skeleton's rule).
 */
const WIDTHS = ['38%', '52%', '30%', '46%', '34%', '50%', '42%', '36%'] as const;

export function AlertsSkeleton() {
  return (
    <div role="status">
      <span className="sr-only">Loading alerts…</span>
      <div aria-hidden="true">
        <div style={{ background: color.surface, border: `1px solid ${color.border}`, borderRadius: radius['5xl'], padding: '18px 20px', marginBottom: 16 }}>
          <Skeleton height={15} width="34%" />
          <Skeleton height={11} width="46%" style={{ marginTop: 8 }} />
        </div>
        <div style={{ background: color.surface, border: `1px solid ${color.border}`, borderRadius: radius['5xl'], padding: '16px 18px', marginBottom: 16 }}>
          <Skeleton height={30} width="70%" />
        </div>
        <div style={{ background: color.surface, border: `1px solid ${color.border}`, borderRadius: radius['6xl'], overflow: 'hidden' }}>
          {WIDTHS.map((w, i) => (
            <div key={i} style={{ padding: '14px 16px', borderTop: i ? `1px solid ${color.borderSubtle}` : 'none' }}>
              <Skeleton height={12} width={w} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
